import { FC, SVGProps } from 'react'

import delivery from 'Icons/fulfillment/delivery.svg'
import pickup from 'Icons/fulfillment/pickup.svg'
import shipping from 'Icons/fulfillment/shipping.svg'
import tableside from 'Icons/fulfillment/tableside.svg'

export default {
  pickup,
  delivery,
  shipping,
  tableside,
} as { [key: string]: FC<SVGProps<SVGSVGElement>> }
